module.exports = __webpack_public_path__ + "static/media/apple.3a18db32.jpg";